export interface CaseStepSummary {
  stepCode: string;
  stepName: string;
  sequence: number;
  status: 'COMPLETED' | 'CURRENT' | 'PENDING';
}

export interface MemberCaseStatusDto {
  memberName: string;
  pin: string;
  pipelineType: string;
  caseReference: string;
  overallStatus: string;
  currentStepCode: string;
  currentStepName: string;
  completedSteps: number;
  totalSteps: number;
  progressPercent: number;
  startDate: string;
  dueDate?: string;
  steps: CaseStepSummary[];
}

export type PipelineType = 'RETIREMENT' | 'TERMINATION' | 'RECIPROCITY';

export const PIPELINE_OPTIONS = [
  { label: 'All Cases', value: '' },
  { label: 'Retirement', value: 'RETIREMENT' },
  { label: 'Termination', value: 'TERMINATION' },
  { label: 'Reciprocity', value: 'RECIPROCITY' },
];

export interface CaseStatusLookupForm {
  pin: string;
  dateOfBirth: string;
  pipelineType?: string;
}
